var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 50,
    viewBox: "0 0 280 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 50V0.328947H55.8042V13.4868H16.317V19.4079H53.5198V30.5921H16.317V38.1579H55.8042V50H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6154 13.4868V0.328947H125.967V13.4868H103.776V50H86.8065V13.4868H64.6154Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.8 0.328947V50H150.28V37.5H178.182C178.834 37.5 180.14 37.8289 180.14 39.1447V50H195.478V35.5263C195.423 34.5395 194.401 32.1382 190.746 30.4276C194.793 29.6382 195.587 27.0285 195.478 25.8224V6.90789C195.478 1.64474 191.779 0.328947 189.93 0.328947H133.8ZM150.117 13.4868V24.0132H179.324C179.705 24.0132 180.466 23.8158 180.466 23.0263V14.9671C180.466 14.4737 180.14 13.4868 178.834 13.4868H150.117Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.126 50L229.58 0H252.587L280 50H261.725L257.809 42.4342H225.827L221.748 50H204.126ZM251.282 28.9474L241.818 10.6908L232.354 28.9474H251.282Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtraLogo);
export default __webpack_public_path__ + "static/media/EtraLogo.05b3822e8f7f4c813d9c13e0d9c661e3.svg";
export { ForwardRef as ReactComponent };